import dayjs from 'dayjs'
import moment from 'moment'
export function formatTime(timestamp) {
  return dayjs(timestamp).format("YYYY/MM/DD HH:mm:ss");
}
export function formatDate(timestamp) {
  return dayjs(timestamp).format("YYYY/MM/DD");
}

function PadZero(str) {
  return new RegExp(/^\d$/g).test(str) ? `0${str}` : str;
}
function formatDroneFlyTime(val) {
  const parsedVal = parseInt(val, 10)
  if (isNaN(parsedVal)) {
    return '0:00:00' // 如果输入不是一个有效的整数，返回0
  }

  const seconds = parsedVal % 60
  const minutes = (parsedVal % 3600) / 60
  const hours = Math.floor(parsedVal / 3600)

  const formattedTime = [`${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`].join('')
  return formattedTime
}
export function dateReminder(item) {
  // 如果任务已完成，则返回'complete'
  if (item.task_stage === '已完成') {
    return 'complete'
  }
  if (!item.end_time) {
    return ''
  }

  // 解析日期字符串
  const delimiter = item.end_time.indexOf('-') > -1 ? '-' : item.end_time.indexOf('/') > -1 ? '/' : ''
  const dateParts = item.end_time.split(delimiter)
  const date = dayjs(dateParts)

  // 当前日期
  const today = dayjs(moment().format('YYYY-MM-DD'))

  // 计算日期差值
  let day_3 = date.diff(today, 'days')
  // 如果日期解析不正确，则返回空字符串
  if (!date.isValid()) {
    return ''
  }

  if (day_3 > -1 && day_3 <= 2) {
    return 'remind'
  }
  if (day_3 < 0) {
    return 'expired'
  }

  // 如果任务在3天后，不返回任何东西
  return ''
}

export let keyIcon = {
  'TaskComponent.Text.LongText': 'iconicon_text',
  'TaskComponent.Text.RichText': 'iconicon_text',
  'TaskComponent.Number.Normal': 'iconicon_number',
  'TaskComponent.Attachment.Attachment': 'iconicon_annex2',
  'TaskComponent.Object.Participant': 'iconicon_participant',
  'TaskComponent.Date.Year': 'iconicon_time1',
  'TaskComponent.Date.Month': 'iconicon_time1',
  'TaskComponent.Date.DateTime': 'iconicon_time1',
  'TaskComponent.Option.SingleBox': 'iconicon_single_choice',
  'TaskComponent.Option.Checkbox': 'iconicon_multiple_choice',
  'TaskComponent.Number.Percentage': 'iconicon_percentage',
  'TaskComponent.Number.Money': 'iconicon_renew',
}
